import { render, staticRenderFns } from "./CMSPageList.vue?vue&type=template&id=d95aff1e&"
import script from "./CMSPageList.vue?vue&type=script&lang=js&"
export * from "./CMSPageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports